<template>
  <div class="popup-box">
    <div class="card-box">
      <div class="card-box-body">
        <div class="title">Gallery</div>
        <div class="price">$<span>{{price}}</span> <span class="small-grey">{{planDurationString}}</span></div>
        <el-tabs
          v-model="activeName"
          @tab-click="handleClick" >
          <el-tab-pane
            label="Subscription"
            name="subscription">
            <!-- <el-dropdown>
          <el-button>
            Frequency
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item>Frequency 1</el-dropdown-item>
              <el-dropdown-item>Frequency 2</el-dropdown-item>
              <el-dropdown-item>Frequency 3</el-dropdown-item>
              <el-dropdown-item>Frequency 4</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown> -->

            <el-select
              v-model="frequency"
              placeholder="Frequency"
              @change="updateFrequencyDropdowns(frequency)"

            >
              <el-option
                v-for="(item, index) in optionFrequency"
                :key="index"
                :value="item.value"
                :label="item.name"
              >
              </el-option>
            </el-select>
            <el-input
              placeholder="Hours"
              v-model="hours"></el-input>
            <el-input
              placeholder="Participants (Up to)"
              v-model="participantsUpTo"></el-input>
            <!-- <el-dropdown
          trigger="click"
          @command="addIsoOutput"
          v-model="test"
        >
          <el-button>
            ISO Outputs
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <template #dropdown>
            <el-dropdown-menu >

              <el-dropdown-item :command="1" :key="1">ISO Output 1</el-dropdown-item>
              <el-dropdown-item :command="2" :key="2">ISO Output 2</el-dropdown-item>
              <el-dropdown-item :command="3" :key="3">ISO Output 3</el-dropdown-item>
              <el-dropdown-item :command="4" :key="4">ISO Output 4</el-dropdown-item>

            </el-dropdown-menu>

          </template>
        </el-dropdown> -->

            <!-- <el-select
          v-model="isoOutputs"
          placeholder="ISO Outputs"
        >
          <el-option  v-for="(item, index) in isoOutputsOptions"
            :key="index"
            :value="item.value"
            :label="item.name"
          ></el-option>
        </el-select> -->
            <el-input
              placeholder="Participants (Up to)"
              v-model="isoOutputs"></el-input>
            <MosaicOutputDropdown
              @mosaicOutputs="handlemosaicOutputs"
              :mosaicOutputsOptions="mosaicOutputsOptionsPrepaid"
              :addMosaicDropdown="addMosaicDropdown" />
            <!-- <div @click="addMosaicOutout()" class="Add_ring_duotone"><img src="../../assets/Add_ring_duotone.svg">Additional Outputs</div> -->
            <div class="Add_ring_duotone"><img src="../../assets/Add_ring_duotone.svg">Additional Outputs</div>

          </el-tab-pane>
          <el-tab-pane
            label="Prepaid"
            name="second">
            <el-input
              placeholder="Hours"
              v-model="hours"></el-input>
            <el-input
              placeholder="Participants"
              v-model="participantsPrepaid"></el-input>
            <el-input
              placeholder="ISO Outputs"
              v-model="isoOutputsPrepaid"></el-input>
            <el-select
              v-model="mosaicOutputsPrepaid"
              placeholder="Mosaic Outputs"
            >
              <el-option
                v-for="(item, index) in mosaicOutputsOptionsPrepaid"
                :key="index"
                :value="item.addonId"
                :label="item.addonName"
              ></el-option>
            </el-select>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="card-footer">
        <el-button @click="handleClickSub">Subscribe Now</el-button>
      </div>

    </div>

    <ConfirmPay
      v-if="showConfirm"
      type="pay"
      :price="price"
      :cycle="gallery.cycle"
      @handlePay="handlePay"
      @handleClose="showFreeConfirm = false" />

  </div>
</template>
<script>
import MosaicOutputDropdown from '../Gallery/MosaicOutputDropdown.vue'
import ConfirmPay from '../ConfirmPay.vue'
import { GET_PLAN_PRICE } from '../../queries'
import { checkOutNewSub, customerPortalStatus } from '../../mutation'
import { Message } from 'element-ui'
import { checkSub } from '../../common/checkuser'
export default {
  data () {
    return {
      price: 0,
      planDurationString: '',
      activeName: 'subscription',
      optionFrequency: [
        {
          value: 'null',
          name: 'Frequency'
        },
        {
          value: 'monthly',
          name: 'Monthly'
        },
        {
          value: 'yearly',
          name: 'Yearly'
        }
      ],
      frequency: null,
      hours: null,
      participantsUpTo: null,
      addMosaicDropdown: 1,
      isoOutputs: null,
      // isoOutputsOptions: [
      //   {
      //     value: "null",
      //     name: "ISO Outputs"
      //   },
      //   {
      //     value: "isoOutput1",
      //     name: "ISO Outputs 1"
      //   },{
      //     value: "isoOutput2",
      //     name: "ISO Outputs 2"
      //   },{
      //     value: "isoOutput3",
      //     name: "ISO Outputs 3"
      //   },{
      //     value: "isoOutput4",
      //     name: "ISO Outputs 4"
      //   },
      // ],
      participantsPrepaid: '',
      isoOutputsPrepaid: '',
      mosaicOutputsPrepaid: null,
      // mosaicOutputsOptionsPrepaid: [
      //     {
      //     value: "null",
      //     name: "Mosaic Outputs"
      //     },
      //     {
      //     value: "mosaicOutput1",
      //     name: "Mosaic Outputs 1"
      //     },{
      //     value: "mosaicOutput2",
      //     name: "Mosaic Outputs 2"
      //     },{
      //     value: "mosaicOutput3",
      //     name: "Mosaic Outputs 3"
      //     },{
      //     value: "mosaicOutput4",
      //     name: "Mosaic Outputs 4"
      //     },
      // ],
      cbInstance: null,
      showConfirm: false
    }
  },
  components: {
    MosaicOutputDropdown,
    ConfirmPay
  },
  methods: {
    handleClickSub () {
      const params = {
        customerId: this.emailid,
        product: 'Partyline'
      }
      checkSub(params).then(res => {
        console.log(res)
        this.showConfirm = res === 'canCharge'
      })
    },
    handlePay () {
      this.subscriptionNow()
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    addMosaicOutout () {
      this.addMosaicDropdown++
    },
    updateFrequencyDropdowns (val) {
      if (val == 'monthly') {
        this.price = 649
        this.planDurationString = 'per month'
      } else if (val == 'yearly') {
        this.planDurationString = 'per year'
        this.price = 649
      } else {
        this.planDurationString = ''
        this.price = 0
      }
    },
    handleQueryPrice () {
      const chargeItems = this.handleChargeItems()
      this.$apollo
        .query({
          query: GET_PLAN_PRICE,
          variables: {
            customerId: this.emailid,
            product: 'Partyline',
            planId: this.gallery.id,
            chargeItems: JSON.stringify(chargeItems)
          }
        }).then(({ data }) => {
          this.price = data && data.previewCustomSubscription && data.previewCustomSubscription.price ? Number(data.previewCustomSubscription.price) : 0
          this.price = this.price / 100
        })
    },

    handlemosaicOutputs (value) {
      this.mosaicOutputsPrepaid = value
      this.handleQueryPrice()
    },

    handleChargeItems () {
      const chargeItems = {
        'partyline-hour': this.hours ? Number(this.hours) : 0
      }
      if (this.activeName === 'subscription') {
        chargeItems['partyline-participant'] = this.participantsUpTo ? Number(this.participantsUpTo) : 0
        chargeItems['partyline-output'] = this.isoOutputs ? Number(this.isoOutputs) : 0
      } else {
        chargeItems['partyline-participant'] = this.participantsPrepaid ? Number(this.participantsPrepaid) : 0
        chargeItems['partyline-output'] = this.isoOutputsPrepaid ? Number(this.isoOutputsPrepaid) : 0
      }
      if (this.mosaicOutputsPrepaid) {
        chargeItems[this.mosaicOutputsPrepaid] = 1
      }
      return chargeItems
    },

    subscriptionNow () {
      const chargeItems = this.handleChargeItems()
      this.$apollo
        .mutate({
          mutation: checkOutNewSub,
          variables: {
            customerId: this.emailid,
            product: 'Partyline',
            planId: this.gallery.id,
            description: 'kk_test',
            chargeItems: JSON.stringify(chargeItems)
          }
        })
        .then((data, loading) => {
          console.log(loading)
          console.log(data)
          // console.log("data ---> ", data);
          this.visible = true
          // this.paymentPath = "https://tvunetworks-test.chargebee.com/pages/v3/V0QigzgDi3StLz2gcB3XDFgPd6b2dKvq/"
          // this.paymentPath = data.data.checkoutNewSubscription.url;
          // console.log(this.paymentPath);
          this.openCheckout(data.data.checkoutNewSubscription.url)
          this.showConfirm = false
        })
        .catch((error) => {
          this.showConfirm = false
          // console.log("error---->", JSON.stringify(error));
          // console.log("error---->", error.graphQLErrors[0].message);
          let errorMessage =
            error &&
            error.graphQLErrors &&
            error.graphQLErrors[0] &&
            error.graphQLErrors[0].message

          console.log(errorMessage)

          errorMessage &&
            Message({
              message: errorMessage,
              type: 'error',
              customClass: 'mzindex'
            })
        })
    },
    openCheckout (checkUrl) {
      let hasPay = false
      this.cbInstance.openCheckout({
        hostedPage: () => {
          // 打开订阅或者支付的窗口
          return new Promise((resolve) => {
            resolve({ url: checkUrl })
          })
        },
        success: async (hostedPageId) => {
          console.log(hostedPageId)
          hasPay = true
          this.customerPortalStatus(hostedPageId)
        },
        error: (err) => {
          console.log(err)
        },
        close: () => {
          console.log('close')
          hasPay && window.parent.postMessage({
            type: 'close',
            data: null
          }, '*')
        }
      })
    },
    customerPortalStatus (hostedPageId) {
      this.$apollo.mutate({
        mutation: customerPortalStatus,
        variables: {
          customerId: this.emailid,
          hostedPageId
        }
      }).then((data) => {
        console.log(data)
      }).catch(err => {
        console.log(err)
      })
    }
  },
  computed: {
    gallery () {
      return this.$store.state.Gallery
    },
    isoOutputsOptions () {
      return []
    },
    mosaicOutputsOptionsPrepaid () {
      return this.gallery ? this.gallery.chargeItems.filter(i => i.addonName.indexOf('Mosaic') > -1) : []
    },
    formData () {
      return [this.hours, this.participantsUpTo, this.isoOutputs, this.participantsPrepaid, this.isoOutputsPrepaid]
    },
    emailid () {
      return this.$store.state.userInfo.email
    }
  },
  watch: {
    formData () {
      this.handleQueryPrice()
    }
  },
  mounted () {
    this.cbInstance = window.Chargebee.getInstance()
  }
}
</script>
<style>
  .el-dropdown-menu{
      background: #E1E8EE!important;
     border: 2px solid #C8CED3;
    box-sizing: border-box;
    box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.1);
    border-radius: 11px;
    width: 260px;
  }

</style>
